"use client";

import { Route } from "@faire/web-api/Route";
import { props as insiderMarketingPageProps } from "@faire/web-api/routes/insider";
import { props as insiderTermsAndConditionsRouteProps } from "@faire/web-api/routes/insider/terms-and-conditions";
import insiderTermsOfService from "@faire/web-api/routes/tos-insider";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";
import { Redirect } from "react-router-dom";

import { useInsiderFeatureEligibility } from "@faire/retailer/hooks/insider/useInsiderFeatureEligibility";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { home } from "@faire/retailer/paths";
import { useSettingInsiderLoggedOutLandingPageEnabled } from "@faire/retailer/settings/useSettingInsiderLoggedOutLandingPageEnabled";
import { LoggedOutInsiderMarketingPage } from "@faire/retailer/views/user/InsiderMarketing/LoggedOutInsiderMarketingPage";

export const RenderInsiderRoutes = () => {
  return (
    <Route {...insiderMarketingPageProps}>
      <InsiderRouter />
    </Route>
  );
};

const InsiderRouter = () => {
  const { hasAccessToInsiderMarketingPage } = useInsiderFeatureEligibility();
  const isInsiderLoggedOutLandingPageEnabled =
    useSettingInsiderLoggedOutLandingPageEnabled();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  return (
    <Switch>
      <Route {...insiderMarketingPageProps} exact>
        {!isLoggedInRetailer &&
        hasAccessToInsiderMarketingPage &&
        isInsiderLoggedOutLandingPageEnabled ? (
          <LoggedOutInsiderMarketingPage />
        ) : (
          <Redirect to={home()} />
        )}
      </Route>
      <Route {...insiderTermsAndConditionsRouteProps}>
        <Redirect to={insiderTermsOfService()} />
      </Route>
    </Switch>
  );
};
